import { flushSync } from "react-dom";

/**
 * Run a navigation inside a View Transition, so an element named the same on
 * both screens (a movement's title) travels to its new place instead of the
 * page swapping under the thumb.
 *
 * The router here is the declarative one, whose own `viewTransition` option
 * does nothing, hence the manual wrap. The update is flushed synchronously so
 * the browser snapshots the new screen, not the old one twice. Browsers
 * without the API, and anyone who asked for less motion, just navigate.
 */
export function withTransition(update: () => void) {
  // The keyboard closes before the screen changes, not by its input being
  // torn out from under it: iOS then left the page short of its height.
  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!document.startViewTransition || reduced) {
    update();
    return;
  }
  document.startViewTransition(() => flushSync(update));
}

/** The shared name a movement's title carries on the list and on its own screen. */
export const exerciseTitle = (sessionExerciseId: number) => `exercise-${sessionExerciseId}`;
